import styled from 'styled-components';
import { Item } from '../Global/ColorPicker';
import {
  SECONDARY_COLOR,
  SECONDARY_COLOR_1,
  SECONDARY_COLOR_2,
  SECONDARY_COLOR_5,
  SECONDARY_COLOR_6
} from '../../const/color';
import { FAMILY_FONT_CONTROL, FAMILY_FONT_PRIMARY, TITLE_SIZE_5 } from '../../const/text';
import { NoticeIcon } from '../../const/icons';
import { CheckBox, Toggle } from '../Global';
import { device } from '../../const/device';

export const SideItem = styled.label<{ icon: string, themeColor: string }>`
  width: 192px;
  height: 48px;
  background: ${props => props.themeColor == 'black' ? '#2e2e2e':SECONDARY_COLOR_6};
  border-radius: 4px;
  padding-left: 64px;
  padding-right: 15px;
  display: inline-flex;
  position: relative;
  align-items: center;
  justify-content: space-between;
  
  &:after {
    content: '';
    position: absolute;
    left: 9px;
    top: -8px;
    width: 48px;
    height: 56px;
    background-image: url(${props => props.icon});
    background-size: cover;
  }
  
  @media (${device.tablet}) {
    width:250px;
    height: 56px;
    &:after {
      width: 54px;
      height: 63px;
    }
  }

  @media (${device.tabletM}) {
    width:180px;
  }

  @media (${device.tabletS}) {
    width:auto;
  }

  @media (${device.mobileL}) {
    font-size: 12px;
    width: calc(50% - 10px);
    margin-right:20px;
    height: 44px;
    padding-left: 16px;
    padding-right: 9px;
    flex: 0 0 auto;

    &:after {
      display: none;
    }
  }
`;

export const SideItemText = styled.span<{ themeColor: string }>`
  font-family: ${FAMILY_FONT_PRIMARY};
  font-size: ${TITLE_SIZE_5}px;
  text-transform: uppercase;
  color: ${props => props.themeColor == 'black' ? '#fff' : SECONDARY_COLOR};
`;
export const SideContainer = styled.div`
  display: grid;
  grid-gap: 32px;
  grid-template-columns: repeat(2, 1fr);
  margin-top: 48px;
  
  @media (${device.tablet}) {
    margin-top: 0;
    margin-left:32px;
  }

  @media (${device.tabletS}) {
    margin-top: 32px;
    margin-left:0;
  }

  @media (${device.mobileL}) {
    margin-top: 16px;
    display: flex;
    padding-bottom: 20px;
    overflow-x: auto;
    overflow-y: hidden;
    grid-gap: 0px;

    &::-webkit-scrollbar {
      height:3px;
    }

    &::-webkit-scrollbar-thumb {
      background:${SECONDARY_COLOR};
    }
  }
`;

export const SponsorWrapper = styled.div`
  @media (${device.mobileL}) {
    ${Toggle.Container} {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 16px;
      //width: 136px;
      > ${Toggle.Item} {
        width: auto;
        height: 40px;
        font-size: ${TITLE_SIZE_5}px;
        border: none;
      }
    }
  }
  
`;

export const NoticeMessageTabs = styled.div<{disOverOther:boolean, themeColor: string}>`
  width: 100%;
  height: 80px;
  padding: 12px 16px;
  margin-top: 40px;
  margin-bottom: 16px;
  color: white;
  font-family: ${FAMILY_FONT_CONTROL};
  font-weight: bold;
  font-size: 12px;
  line-height: 160%;
  display: ${ props => props.disOverOther ? 'flex' : 'none'};
  position: absolute;
  z-index: 110000;
  align-items: center;
  border-radius: 2px;
  text-align: center;
  background-color: black;
  border: ${props => props.themeColor == 'black' ? '1px solid #ffffff' : '1px solid #000000'};
`;

export const NoticeMessage = styled.div`
  width: 100%;
  padding: 12px 16px;
  margin-top: 40px;
  margin-bottom: 16px;
  color: white;
  font-family: ${FAMILY_FONT_CONTROL};
  font-weight: bold;
  font-size: 12px;
  line-height: 160%;
  display: flex;
  align-items: center;
  border-radius: 2px;
  background-color: black;
  
    
  &:before {
    content: '';
    background: black url("data:image/svg+xml,${NoticeIcon()}") center no-repeat;
    margin-right: 12px;
    border-radius: 2px;
    width: 24px;
    height: 40px;
    flex: 0 0 auto;
    display: inline-block;
  }
  
  
  @media (${device.tablet}) {
    margin-top: 32px;
    padding-top: 12px;
    &:before {
      width: 19px;
      height: 19px;
      margin-right: 12px;
      background-color: transparent;
      background-size: contain;
    }
  }

  @media (${device.mobileL}) {
    margin-top: 24px;
  }
`;

export const TeamWrapper = styled.div`
  
  @media (${device.tablet}) {
    display: flex;
    justify-content: space-between;
  }
  @media (${device.tabletS}) {
    flex-direction: column;
  }
`;


export const MobileHeader = styled.div`
  position: absolute;
  top: 0px;
  left: 0;
  width: 100%;
  
  display: flex;
  flex-direction: row;
  height: 28px;
  padding-bottom: 5px;
  align-items: end;
  justify-content: space-between;
  background: white;
`;
export const MobileTitleContainer = styled.div`
  font-size: ${TITLE_SIZE_5}px;
  line-height: 130%;
  color: ${SECONDARY_COLOR};
  letter-spacing: 0.005em;
  text-transform: uppercase;
`;


export const FlagWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid ${SECONDARY_COLOR_5};
  padding-top: 16px;
  margin-top: 32px;
  
  > ${CheckBox.Item} {
    margin-left: auto;
  }
  
  @media (${device.mobileL}) {
    margin-top: 16px;
  }
`;


export const FlagItem = styled.div<{ flag: string | null }>`
  display: flex;
  align-items: center;
  cursor: pointer;
  
  &:before {
    content: '';
    width: 40px;
    height: 28px;
    background: ${props => props.flag ? `url("${props.flag}")` : "none"};

    background-color: ${props => props.flag ? 'transparent' : SECONDARY_COLOR_2};
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;;
  }
  &:after {
    content: 'Add your flag';
    padding-left: 16px;
    font-family: ${FAMILY_FONT_CONTROL};
    font-size: ${TITLE_SIZE_5}px;
    line-height: 160%;
  }
`;
